// Words that will never have a capital letter at the start (unless they're the first word)
export var TITLE_CASE_STOP_WORDS = [
    'a',
    'an',
    'the',
    'and',
    'so',
    'as',
    'than',
    'but',
    'that',
    'for',
    'till',
    'if',
    'when',
    'nor',
    'yet',
    'once',
    'or',
    'at',
    'off',
    'by',
    'on',
    'down',
    'onto',
    'for',
    'over',
    'from',
    'past',
    'before',
    'after',
    'in',
    'to',
    'into',
    'upon',
    'near',
    'with',
    'of',
];
/** @returns `true` if `text` contains one or more uppercase characters */
function includesUppercase(text) {
    for (var index = 0; index < text.length; index++) {
        var letter = text[index];
        if (letter === letter.toUpperCase() &&
            // Avoid false positives for non-alphabetical characters:
            letter !== letter.toLowerCase()) {
            return true;
        }
    }
    return false;
}
/**
 * Convert string content into Title Case. Words that contain uppercase characters
 * (such as “iPhone”, “GitHub”, “SQL”, etc.) will be left unchanged, provided that
 * they’re not included in the list of stop words.
 *
 * @param content string, the content to be converted into Title Case
 * @returns content in Title Case
 */
export function setTitleCase(content) {
    return content.length === 0
        ? content
        : content
            .trim()
            .split(' ')
            .reduce(function (output, word, index) {
            var lowercaseWord = word.toLowerCase();
            // Always capitalize the first letter of the first word or if it’s not already capitalised and not included in our stop words
            if (TITLE_CASE_STOP_WORDS.includes(lowercaseWord) && index > 0) {
                return output.concat(' ', lowercaseWord);
            }
            var wordToAppend = includesUppercase(word) || word.length === 0
                ? word
                : "".concat(lowercaseWord[0].toUpperCase()).concat(lowercaseWord.substring(1));
            return output.concat(index === 0 ? '' : ' ', wordToAppend);
        }, '');
}
